export default "__VITE_ASSET__nNQMHj6h__"